import Vue from "vue";
import VueApollo from "vue-apollo";
import { ApolloClient } from "apollo-client";
import { InMemoryCache } from "apollo-cache-inmemory";
import { ApolloLink } from "apollo-link";
import { createUploadLink } from "apollo-upload-client";
import { setContext } from "apollo-link-context";
import { onError } from "apollo-link-error";
import { split } from "apollo-link";
import { WebSocketLink } from "apollo-link-ws";
import { getMainDefinition } from "apollo-utilities";
import { getToken } from "./services/UserService";

Vue.use(VueApollo);

let provider = null;

function createClient() {
  const wsLink = new WebSocketLink({
    uri: process.env.VUE_APP_SUBSCRIPTION_URL,
    options: {
      reconnect: true,
      connectionParams: () => ({
        authToken: getToken(),
      }),
    },
  });

  const authLink = setContext(async (_, { headers }) => {
    const token = getToken();
    return {
      headers: {
        ...headers,
        Authorization: token ? `Bearer ${token}` : "",
      },
    };
  });

  const errorLink = onError(({ graphQLErrors, networkError }) => {
    if (graphQLErrors) {
      graphQLErrors.forEach(({ extensions }) => {
        if (extensions.code === "UNAUTHENTICATED") {
          window.dispatchEvent(new Event("loginIsExpired"));
        }
      });
    } else if (networkError) {
      console.log(`[Network error]: ${networkError}`);
    }
  });

  const uploadLink = createUploadLink({
    uri: process.env.VUE_APP_API_URL,
  });

  const combineWSLink = ApolloLink.from([errorLink, wsLink]);
  const combineHttpLink = ApolloLink.from([errorLink, authLink, uploadLink]);
  const link = split(
    ({ query }) => {
      const definition = getMainDefinition(query);
      return (
        definition.kind === "OperationDefinition" &&
        definition.operation === "subscription"
      );
    },
    combineWSLink,
    combineHttpLink
  );

  const cache = new InMemoryCache({
    addTypename: false,
  });

  const client = new ApolloClient({
    link,
    cache,
    defaultOptions: {
      fetchPolicy: "cache-and-network",
    },
  });
  return client;
}

/**
 * Create VueApollo Provider.
 */
export function getProvider() {
  if (!provider) {
    provider = new VueApollo({
      defaultClient: createClient(),
      defaultOptions: {
        $query: {
          fetchPolicy: "cache-and-network",
        },
      },
    });
  }
  return provider;
}
